export function isWholePositiveNumber(value: unknown): boolean {
  // Returns true if the given value matches a regex for a whole number.
  return /^\d+$/.test(String(value));
}

export const isNumeric = (value: unknown): boolean =>
  // Returns true if the given value is a finite number
  !Number.isNaN(parseFloat(String(value))) && Number.isFinite(value);
